<template>
	<div id="book-detail" v-if="book">
		<div class="book-info" style="display: flex">
			<div class="book-cover">
				<img :src="book.cover" style="width: 252px; height: 332px; border-radius: 5px" />
			</div>
			<div class="book-info-right" style="margin-left: 20px; width: 500px">
				<el-form>
					<el-form-item label="教材名称">
						<span>{{ book.name }}</span>
					</el-form-item>
					<el-form-item label="教材简介">
						<div>{{ book.description }}</div>
					</el-form-item>
					<el-form-item label="创建时间">
						<span>{{ book.createTime }}</span>
					</el-form-item>
				</el-form>
			</div>
		</div>
		<div class="group-list" style="margin-top: 20px">
			<div class="chapter-item" v-for="(item, index) in chapterList" :key="index">
				<div class="chapter-title">
					<span class="group-name">
						<span>{{ item.name }}</span>
						<img
							:src="item.cover"
							style="
								width: 80px;
								height: 50px;
								margin-left: 20px;
								border-radius: 4px;
								vertical-align: middle;
								cursor: pointer;
							"
							@click="showChapterEditor(item)"
						/>
						<span style="margin-left: 10px; font-weight: 400" v-for="(reading, index) in item.readingItems" :key="index"
							>《{{ reading.name }}》</span
						>
						<span
							style="margin-left: 20px; font-size: 16px; font-weight: 400; cursor: pointer"
							@click="showReadingSelector(item)"
							>关联读本章节+</span
						>
					</span>
					<span>
						<el-button size="medium" type="text" @click="showCourseItemAdd(item, null)"> 创建识字 </el-button>
						<el-button size="medium" type="text" @click="showChapterEditor(item)"> 编辑 </el-button>
						<el-button size="medium" type="text" @click="deleteChapter(item)"> 删除 </el-button>
					</span>
				</div>
				<div class="word-item-left-part" v-if="item.children.length !== 0">
					<span style="margin-left: 30px">字</span>
					<span style="margin-left: 120px">图</span>
					<span style="margin-left: 90px">是否上架</span>
					<span style="margin-left: 90px">音频</span>
					<span style="margin-left: 90px">排序</span>
					<span style="margin-left: 150px">视频</span>
					<span style="margin-left: 100px">词语</span>
					<span style="margin-left: 40px">造句</span>
				</div>
				<div class="chapter-sub" v-for="(sub, subIndex) in item.children" :key="subIndex">
					<div class="chapter-sub-title">
						<div class="word-item-left-part">
							<span class="word">{{ sub.word }}</span>
							<img
								:src="sub.images[0]"
								style="margin-left: 60px; width: 100px; height: 100px; vertical-align: middle"
							/>
							<el-switch
								style="margin-left: 50px"
								active-value="1"
								inactive-value="0"
								v-model="sub.enable"
								@change="onUpShopChange(sub)"
							></el-switch>
							<el-button type="info" style="margin-left: 70px" size="medium" @click="doItemPlay(sub.mp3Id)"
								>播放音频
							</el-button>
							<div style="width: 90px; margin-left: 20px; text-align: center">
								<span>{{ sub.ord }}</span>
							</div>
							<div class="word-item-video">
								<img :src="sub.videoCover" style="width: 160px; height: 90px; vertical-align: middle" />
								<div class="video-cover" @click="playVideo(sub.videoId)">
									<span class="el-icon-video-play"></span>
								</div>
							</div>
							<div class="word-phrase" style="padding-left: 35px">
								{{ sub.phrase }}
							</div>
							<div class="word-sentence" style="padding-left: 45px">
								{{ sub.sentence }}
							</div>
						</div>
						<span>
							<el-button type="text" @click="showCourseItemAdd(item, sub)"> 编辑 </el-button>
							<el-popconfirm @confirm="deleteCourseItem(sub.id)" title="确定删除当前识字吗？">
								<el-button slot="reference" type="text" style="margin-left: 20px">删除</el-button>
							</el-popconfirm>
						</span>
					</div>
				</div>
			</div>
			<div class="add-chapter-action" @click="showChapterEditor(null)">
				<span>添加分组+</span>
			</div>
		</div>
		<div class="dialog-part">
			<el-dialog :title="dialogText" :visible.sync="addCourseChapter" center width="600px">
				<div>
					<el-form label-width="100px" size="medium">
						<el-form-item label="标题" :required="true">
							<el-input type="text" maxlength="8" show-word-limit v-model="chapterInfo.name"></el-input>
						</el-form-item>
						<el-form-item label="读本名" :required="true">
							<el-input v-model="chapterInfo.readingName"></el-input>
						</el-form-item>
						<el-form-item label="封面" :required="true">
							<div class="form-item-container">
								<el-upload
									accept="image/jpeg,image/png,image/jpg"
									:show-file-list="false"
									:http-request="uploadWordGroupCover"
									action=""
								>
									<div class="word-group-cover">
										<img v-if="chapterInfo.cover" :src="chapterInfo.cover" class="avatar" />
										<i v-else class="el-icon-plus avatar-uploader-icon"></i>
									</div>
								</el-upload>
							</div>
							<div class="form-des-text">支持JPEG/PNG，不超过1M，推荐16:9</div>
						</el-form-item>
						<el-form-item label="顺序" :required="true">
							<el-input-number v-model="chapterInfo.ord" :min="0"></el-input-number>
						</el-form-item>
						<el-form-item label="我爱阅读" :required="true">
							<!--                            <el-input-number v-model="chapterInfo.loveRead" :min="0" :max="100"></el-input-number>-->
							<!--                            <el-switch v-model="chapterInfo.loveRead" />-->
							<el-switch
								v-model="chapterInfo.loveRead"
								size="large"
								active-text="是"
								inactive-text="否"
								:active-value="1"
								:inactive-value="0"
							/>
						</el-form-item>
						<el-form-item label="分组标题" :required="true">
							<el-input v-model="chapterInfo.description" type="text" maxlength="8" show-word-limit></el-input>
							<!-- <tinymce-editor v-model="chapterInfo.description" @input="contentChange" /> -->
						</el-form-item>
						<el-form-item label="课程介绍" :required="true">
							<tinymce-editor v-model="chapterInfo.content" @input="contentChange" />
						</el-form-item>
						<!--            <el-form-item label="石头" :required="true">-->
						<!--              <el-select v-model="chapterInfo.payWith">-->
						<!--                <el-option value="0" label="免费"></el-option>-->
						<!--                <el-option value="1" label="绿色石头"></el-option>-->
						<!--                <el-option value="2" label="蓝色石头"></el-option>-->
						<!--                <el-option value="3" label="红色石头"></el-option>-->
						<!--              </el-select>-->
						<!--            </el-form-item>-->
						<!--            <el-form-item label="单价" :required="true" v-if="chapterInfo.payWith!==null&&chapterInfo.payWith!=='0'">-->
						<!--              <el-input-number v-model="chapterInfo.price" :min="1"></el-input-number>-->
						<!--            </el-form-item>-->
					</el-form>
				</div>
				<span slot="footer" class="dialog-footer">
					<el-button @click="onChapterCancel" size="medium">取 消</el-button>
					<el-button type="primary" @click="postChapter" size="medium">提 交</el-button>
				</span>
			</el-dialog>

			<el-dialog title="读本章节关联" :visible.sync="isReadingListShow" center width="600px">
				<div>
					<el-form :inline="true" size="medium">
						<!-- <el-form-item>
							<el-select
								v-model="targetReadingId"
								filterable
								remote
								reserve-keyword
								placeholder="请输入读本名称"
								:remote-method="likeReading"
							>
								<el-option v-for="item in readingList" :key="item.id" :label="item.name" :value="item.id"> </el-option>
							</el-select>
						</el-form-item> -->
						<el-cascader
							style="width: 70%"
							v-model="targetReadingId"
							:options="readingList"
							@change="handleChange"
							:props="{ label: 'name', value: 'id', children: 'readingItemList' }"
							filterable
						></el-cascader>
						<el-form-item>
							<el-button type="primary" style="margin-left: 10px" @click="addReading">添加</el-button>
						</el-form-item>
					</el-form>
				</div>

				<div class="reading-list">
					<el-table :data="groupReadingList" style="width: 100%">
						<el-table-column prop="name" align="center" label="读本章节名"> </el-table-column>
						<el-table-column align="center" width="200" label="操作">
							<template slot-scope="scope">
								<div style="display: flex; justify-content: center">
									<el-popconfirm
										confirm-button-text="马上删除"
										cancel-button-text="我后悔了"
										icon="el-icon-info"
										@confirm="deleteReading(scope.row)"
										icon-color="red"
										title="确定删除该读本吗？"
									>
										<el-button slot="reference" type="danger" size="mini"> 删除 </el-button>
									</el-popconfirm>
								</div>
							</template>
						</el-table-column>
					</el-table>
				</div>
				<span slot="footer" class="dialog-footer">
					<el-button @click="onAddReadingCancel()" type="info" size="medium">关 闭</el-button>
				</span>
			</el-dialog>
			<word-editor ref="wordEditor" @onPostWordSuccess="listGroup"></word-editor>
			<el-dialog width="700px" center @close="videoPath = ''" :visible.sync="videoPreviewShow">
				<video v-if="videoPath !== ''" :src="videoPath" controls></video>
			</el-dialog>
		</div>
		<audio :src="targetPlayUrl" id="audio"></audio>
	</div>
</template>
<script>
import * as api from "../../api/api";
import wordEditor from "../../component/WordEditor";
import tinymceEditor from "@/component/editor.vue";

export default {
	components: {
		wordEditor,
		tinymceEditor,
	},
	data() {
		return {
			isAddWordShow: true,
			videoPreviewShow: false,
			dialogText: "",
			bookId: "",
			moduleId: "",
			book: null,
			chapterList: [],
			addCourseChapter: false,
			targetReadingId: "",
			wordGroupReading: {
				wordGroupId: "",
				readingId: [],
			},
			chapterInfo: {
				id: "",
				name: "",
				ord: 0,
				description: "",
				content: "",
				bookId: "",
				cover: "",
				loveRead: 0,
				readingName: "",
				price: 0,
				payWith: "0",
				moduleId: "0",
			},
			selectModuleIds: [],
			appModuleTreeData: [],
			targetPlayUrl: "",
			videoPath: "",
			isReadingListShow: false,
			readingList: [],
			targetGroupId: "",
			groupReadingList: [],
			content: "",
		};
	},
	methods: {
		contentChange(data) {
			this.content = data;
		},
		getModuleTreeData() {
			api.getAppModuleTree().then((result) => {
				if (result.code === api.SUCCESS_CODE) {
					this.appModuleTreeData = result.data;
				}
			});
		},
		deleteReading(item) {
			let id = item.id;
			api.deleteGroupReading(this.targetGroupId, id).then((result) => {
				if (result.code === api.SUCCESS_CODE) {
					this.groupReadingList.forEach((i, index) => {
						if (i.id === id) {
							this.groupReadingList.splice(index, 1);
						}
					});
					this.$message.success(result.msg);
				} else {
					this.$message.error(result.msg);
				}
			});
		},
		onAddReadingCancel() {
			this.isReadingListShow = false;
			this.targetGroupId = "";
			this.targetReadingId = "";
		},
		addReading() {
			try {
				if (!this.targetReadingId || this.targetReadingId === "") {
					return this.$message.error("请选择读本章节");
				}

				// 检查是否已有关联读本
				if (this.groupReadingList.length > 0) {
					// 弹出确认替换提示
					this.$confirm("当前已关联一个读本，是否要替换？", "提示", {
						confirmButtonText: "确认替换",
						cancelButtonText: "取消",
						type: "warning",
					})
						.then(() => {
							// 先删除旧的关联
							const oldReadingId = this.groupReadingList[0].id;
							return api.deleteGroupReading(this.targetGroupId, oldReadingId);
						})
						.then(() => {
							// 再添加新的关联
							api.postWordGroupReading(this.targetGroupId, this.targetReadingId[1]).then((res) => {
								if (res.code === 20000) {
									this.$message.success("替换成功");
									this.listGroup(); // 刷新数据
								}
							});
						})
						.catch(() => {
							// this.$message.error("操作失败，请重试");
						});
				} else {
					// 直接添加新关联
					api.postWordGroupReading(this.targetGroupId, this.targetReadingId[1]).then((result) => {
						if (result.code === api.SUCCESS_CODE) {
							this.$message.success(result.msg);
							this.listGroup();
						} else {
							this.$message.error(result.msg);
						}
					});
				}
			} catch (error) {
				console.log(error);
			}
		},
		likeReading(moduleId, query) {
			api.likeReading(moduleId, query).then((result) => {
				if (result.code === api.SUCCESS_CODE) {
					//替换result.data 的数据readingItemList为children，children的sentence为name
					if (result.data) {
						this.readingList = result.data.map((item) => {
							return {
								...item,
								readingItemList: item.readingItemList.map((i) => {
									return {
										...i,
										name: i.name,
									};
								}),
							};
						});
					}
				}
			});
			// if (query !== '') {
			// }
		},
		handleChange(value) {
			console.log(value, this.targetReadingId);
		},
		showReadingSelector(item) {
			console.log(item);
			this.targetGroupId = item.id;
			this.groupReadingList = item.readingItems;

			this.isReadingListShow = true;
		},
		uploadWordGroupCover(object) {
			let formData = new FormData();
			formData.append("image", object.file);
			api
				.postWordGroupCover(formData)
				.then((result) => {
					if (result.code === api.SUCCESS_CODE) {
						let url = result.data;
						this.$message({
							message: "分组封面上传成功.",
							type: "success",
							center: true,
						});
						this.chapterInfo.cover = url;
					} else {
						this.$message.error(result.msg);
					}
				})
				.catch((err) => {
					console.log(err);
					this.$message({
						message: "分组封面出错",
						type: "error",
						center: true,
					});
				});
		},
		onUpShopChange(item) {
			//获取到item的值，去更新
			this.wordItem.id = item.id;
			this.wordItem.enable = item.enable;
			api.updateWordItem(item).then((result) => {
				if (result.code === api.SUCCESS_CODE) {
					this.$message.success(result.msg);
					this.onWordCancel();
				} else {
					this.$message.error(result.msg);
				}
			});
		},
		playVideo(videoId) {
			//去获取令牌
			api.getVideoToken(videoId).then((result) => {
				console.log(result);
				if (result.code === api.SUCCESS_CODE) {
					this.videoPreviewShow = true;
					this.videoPath = result.data.url;
				}
			});
		},
		doItemPlay(mp3Id) {
			//去获取令牌
			api.getMp3PlayToken(mp3Id).then((result) => {
				if (result.code === api.SUCCESS_CODE) {
					this.targetPlayUrl = result.data.url;
					let audio = document.getElementById("audio");
					if (audio) {
						this.$nextTick(function () {
							audio.play();
						});
					}
				} else {
					this.$message.error(result.msg);
				}
			});
		},

		onChapterCancel() {
			this.addCourseChapter = false;
			this.chapterInfo.description = "";
			this.chapterInfo.content = "";
			this.chapterInfo.ord = "";
			this.chapterInfo.name = "";
			this.chapterInfo.readingName = "";
			this.chapterInfo.price = 0;
			this.chapterInfo.payWith = "0";
			this.chapterInfo.moduleId = "0";
		},
		postChapter() {
			this.chapterInfo.moduleId = this.selectModuleIds[this.selectModuleIds.length - 1];
			if (this.chapterInfo.id === "") {
				this.chapterInfo.bookId = this.bookId;
				api.postWordGroup(this.chapterInfo).then((result) => {
					if (result.code === api.SUCCESS_CODE) {
						this.onChapterCancel();
						this.$message.success(result.msg);
						this.listGroup();
					} else {
						this.$message.error(result.msg);
					}
				});
			} else {
				//走更新
				api.updateWordGroup(this.chapterInfo).then((result) => {
					if (result.code === api.SUCCESS_CODE) {
						this.onChapterCancel();
						this.$message.success(result.msg);
						this.listGroup();
					} else {
						this.$message.error(result.msg);
					}
				});
			}
		},
		deleteChapter(item) {
			let groupId = item.id;
			api.deleteWordGroup(groupId).then((result) => {
				if (result.code === api.SUCCESS_CODE) {
					this.$message.success(result.msg);
					this.listGroup();
				} else {
					this.$message.error(result.msg);
				}
			});
		},
		showCourseItemAdd(group, item) {
			this.$refs.wordEditor.showWordEditor(this.bookId, this.moduleId, group.id, item);
		},
		deleteCourseItem(wordId) {
			api.deleteWordItem(wordId).then((result) => {
				if (result.code === api.SUCCESS_CODE) {
					this.$message.success(result.msg);
					this.listGroup();
				} else {
					this.$message.error(result.msg);
				}
			});
		},
		showChapterEditor(item) {
			this.selectModuleIds = [];
			if (item) {
				this.dialogText = "编辑分组";
				this.chapterInfo.bookId = this.bookId;
				this.chapterInfo.name = item.name;
				this.chapterInfo.id = item.id;
				this.chapterInfo.cover = item.cover;
				this.chapterInfo.readingName = item.readingName;
				this.chapterInfo.description = item.description;
				this.chapterInfo.content = item.content;
				this.chapterInfo.ord = item.ord;
				this.chapterInfo.loveRead = item.loveRead;
				this.chapterInfo.price = item.price;
				this.chapterInfo.payWith = item.payWith;
				this.chapterInfo.moduleId = item.moduleId;
				this.selectModuleIds.push(item.moduleId);
			} else {
				this.dialogText = "创建分组";
			}
			this.addCourseChapter = true;
		},
		listGroup() {
			api.listWordGroup(this.bookId).then((result) => {
				if (result.code === api.SUCCESS_CODE) {
					this.chapterList = result.data;
					if (this.targetGroupId !== "") {
						this.chapterList.forEach((i) => {
							if (i.id === this.targetGroupId) {
								this.groupReadingList = i.readingItems;
							}
						});
					}
				}
			});
		},

		getBookDetail() {
			api.getBookDetail(this.bookId).then((result) => {
				if (result.code === api.SUCCESS_CODE) {
					this.book = result.data;
					this.moduleId = result.data.moduleId;
					this.listGroup();
					// 查询读本
					this.likeReading(this.moduleId, "");
				}
			});
		},
	},
	mounted() {
		this.bookId = this.$route.query.bookId;
		if (this.bookId) {
			this.getBookDetail();
		}

		this.getModuleTreeData();
	},
};
</script>
<style scoped>
.word-group-cover {
	text-align: center;
	cursor: pointer;
	line-height: 100px;
	margin-right: 20px;
	width: 160px;
	height: 100px;
	border-radius: 4px;
	border: rgba(0, 0, 0, 0.2) dashed 1px;
}

.word-group-cover img {
	width: 100%;
	height: 100%;
	border-radius: 4px;
}

.word-item-video {
	margin-left: 60px;
	height: 90px;
	width: 160px;
	position: relative;
}

.video-cover:hover {
	background: rgba(0, 0, 0, 0.5);
	color: white;
}

.video-cover {
	cursor: pointer;
	height: 100%;
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	color: black;
	font-size: 30px;
	left: 0;
	top: 0;
	position: absolute;
	background: rgba(0, 0, 0, 0.1);
}

.add-chapter-action:hover {
	background: #f5f5f5;
}

.add-chapter-action {
	cursor: pointer;
	margin-top: 20px;
	color: #666666;
	background: rgba(0, 0, 0, 0.02);
	text-align: center;
	border-radius: 4px;
	font-size: 16px;
	line-height: 40px;
	padding: 10px;
}

.chapter-title {
	line-height: 60px;
	border-radius: 4px;
	background: rgba(0, 0, 0, 0.02);
	padding: 10px 0;
	margin-bottom: 10px;
}

.chapter-title,
.chapter-sub-title {
	flex: 1;
	display: flex;
	align-items: center;
	justify-content: space-between;
	font-size: 16px;
	padding-right: 8px;
	padding-left: 8px;
}

.book-info-right .el-form-item {
	margin-bottom: 0 !important;
}

.group-name {
	font-size: 18px;
	font-weight: 600;
	padding: 0 10px;
}

.image-action-part span {
	padding: 5px;
	cursor: pointer;
	font-size: 20px;
	display: inline-block;
	background: rgba(0, 0, 0, 0.5);
	border-radius: 50%;
	color: white;
}

.word-item-left-part .word {
	font-size: 30px;
	font-weight: 600;
	background: rgba(0, 0, 0, 0.2);
	line-height: 30px;
	color: white;
	border-radius: 50%;
	text-align: center;
	padding: 20px;
}

.word-item-left-part {
	align-items: center;
	margin-bottom: 20px;
	display: flex;
}
</style>
